document.addEventListener('DOMContentLoaded', function () {
    var win_width = $(window).width();
    var win_height = $(window).height();
    var scrollmagic_offset = (win_height / 800) * 400;

    console.log('offset!!!', scrollmagic_offset, 'winheight', win_height);
    var arr = [];
    for (var i = 1; i < 21; i++) {
        arr.push('https://cdn.shopify.com/s/files/1/2548/9034/files/nphlsp-' + i + '.webp?v=1671429175');
    }
    var images = arr;

    // TweenMax can tween any property of any object. We use this object to cycle through the array
    var obj = { curImg: 0 };
    var controller_sec2 = new ScrollMagic.Controller();
    if (win_width >= 1024) {
        var sec2_timeline = new TimelineMax();

        sec2_timeline

            .add([
                TweenMax.to('#ct-2', 0.5, { className: '+=gddwzl_kei' }),
                TweenMax.to('#ct-2-pro', 0.5, { css: { display: 'block' } }),
                TweenMax.to('#ct-2-pro', 5, { opacity: '1' }),
                //TweenMax.to("#ct-2-pro", .5, {css: {  display: "block" },}),
                //TweenMax.to("#ct-2-pro_wap", .5, {css: {  display: "block" },}),
            ])
            .add([
                TweenMax.to(obj, 20, {
                    curImg: images.length - 1, // animate propery curImg to number of images
                    roundProps: 'curImg', // only integers so it can be used as an array index
                    repeat: 0, // repeat 3 times
                    immediateRender: true, // load first image automatically
                    ease: Linear.easeNone, // show every image the same ammount of time
                    onUpdate: function () {
                        $('#ct-2-pro').attr('src', images[obj.curImg]); // set the image source
                    },
                }),
                //TweenMax.to("#ct-2-pro", .5, {css: {  display: "block" },}),
                //TweenMax.to("#ct-2-pro_wap", .5, {css: {  display: "block" },}),
            ])
            .add([
                TweenMax.to('#ct-2-pro', 3, { css: { transform: 'translate(-50%,-50%) scale(.65)' } }),
                TweenMax.to('#ct-2-pro', 3, { css: { top: '60%' } }),
            ])
            .add([
                TweenMax.to('#ct-2-pro', 0.5, { css: { display: 'none' } }),
                TweenMax.to('#ct-2-pro_wap', 0.5, { css: { display: 'block' }, delay: 0.5 }),
                //TweenMax.to("#ct-2-pro", 5, {opacity:"1"}),
                //TweenMax.to("#ct-2-pro_wap", 5, {opacity:"1"}),
            ])

            .add([
                TweenMax.to('.np-sec2-slogan-box', 0.5, { css: { display: 'block' } }),
                TweenMax.to('.np-sec2-slogan-box', 5, { opacity: '1', delay: 2 }),
                TweenMax.to('.np-sec2-slogan-box', 11, { className: '+=np-sec2-slogan-up' }),
            ]);

        new ScrollMagic.Scene({ triggerElement: '#ct-2', duration: 2000, offset: scrollmagic_offset })
            .setTween(sec2_timeline)
            .setPin('#ct-2')
            .addTo(controller_sec2);
    } else {
        // mobile donghua
        var sec2_timeline = new TimelineMax();
        let scrollmagic_offset = ((win_height / 800) * 360) / 2;

        //let scrollmagic_offset = 340;
        sec2_timeline.add([
            TweenMax.to('#ct-2-pro_wap', 0.5, { className: '+=np-sec1-mb-dz' }),
            //TweenMax.to("#ct-2-pro_wap", .5, {css: {  transform: "translate(-50%,0%) scale(1)" },}),
            TweenMax.to('.ct-2-pro-wap-css', 0.5, { opacity: '1' }),
            TweenMax.to('#ct-2-pro_wap', 0.1, { css: { display: 'block' } }),
            //TweenMax.to(".np-sec2-slogan-box", .1, {css: {  display: "block" },}),
            //TweenMax.to(".np-sec2-slogan-box", .5, {opacity:"1",}),
            TweenMax.to('.np-sec2-slogan-box', 0.5, { className: '+=np-sec2-slogan-up' }),
        ]);
        new ScrollMagic.Scene({ triggerElement: '#ct-2', duration: 100, offset: scrollmagic_offset })
            .setTween(sec2_timeline)
            //.setPin("#ct-2")
            .addTo(controller_sec2);
    }
});
